<mat-progress-bar mode="indeterminate"></mat-progress-bar>
<div class="p-8">
    <div class="flex items-center">
        <mat-icon class="icn-spinner" [svgIcon]="'tabler_outline:rotate-clockwise-2'"></mat-icon>
        <div class="px-6">
            <h3>{{title}}</h3>
            {{content}}
        </div>
    </div>
</div>